const splashScreenEl: Element = document.getElementsByClassName('js-splash-screen')[0];

export class SplashScreen {
    public static show({ showOnlyDomestic, showOnlyCommercial, showOnlyPOS } : { showOnlyDomestic?: boolean, showOnlyCommercial?: boolean, showOnlyPOS?: boolean } = {}): void {
        if (showOnlyPOS) {
            this.removeCommercialSplash();
            this.removeDomesticSplash();
        } else {
            if (showOnlyDomestic) {
                this.removeCommercialSplash();
            } else if (showOnlyCommercial) {
                this.removeDomesticSplash();
            }
        }

        splashScreenEl.classList.remove('hidden');
    }

    public static onGetStartedClick(callback: Function): void {
        [].slice.call(splashScreenEl.getElementsByClassName('js-splash-screen-button')).forEach((el: Element) => { 
            el.addEventListener('click', async () => {
                splashScreenEl.classList.add('hidden');
    
                if (callback) {
                    callback(el.getAttribute('data-catalogue'));
                }
            });
        });
    }

    public static setPOSSplashContent({ headerImage, title, introduction, partnershipLogo, marshallsLogo } : { headerImage: string, title: string, introduction: string, partnershipLogo?: string, marshallsLogo?: string }): void {
        if (!headerImage || !title || !introduction || !partnershipLogo) {
            console.error('Unable to set splash content');
            return;
        }

        const posSplashEl: Element = document.getElementsByClassName('js-pos-splash')[0];
        if (!posSplashEl) {
            console.error('Unable to get posSplashEl');
            return;
        }

        const posHeaderImageEl: HTMLImageElement = posSplashEl.getElementsByClassName('js-pos-splash-header-image')[0] as HTMLImageElement;
        const posTitleEl: HTMLElement = posSplashEl.getElementsByClassName('js-pos-splash-title')[0] as HTMLElement;
        const posIntroductionEl: HTMLElement = posSplashEl.getElementsByClassName('js-pos-splash-blurb')[0] as HTMLElement;
        const posPartnershipLogoEl: HTMLImageElement = posSplashEl.getElementsByClassName('js-pos-splash-partner-logo')[0] as HTMLImageElement;
        const posMarshallsLogoEl: HTMLImageElement = posSplashEl.getElementsByClassName('js-pos-splash-marshalls-logo')[0] as HTMLImageElement;

        posHeaderImageEl.src = headerImage;
        posTitleEl.innerHTML = title;
        posIntroductionEl.innerHTML = introduction;
        posPartnershipLogoEl.src = partnershipLogo;
        posMarshallsLogoEl.src = marshallsLogo;


        posSplashEl.classList.remove('hidden');
    }

    private static removeCommercialSplash() {
        document.getElementsByClassName('js-commercial-splash')[0].remove();
    }

    private static removeDomesticSplash() {
        document.getElementsByClassName('js-domestic-splash')[0].remove();
    }
}